var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Radio } from "../Radio/Radio";
import { INPUT_GROUP, INPUT_LABEL, RADIO_GROUP } from "../../../classConstants";
import { Flex } from '../../Flex';
import { ErrorTypes, ErrorText } from '../ErrorMessages';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import { getClassName } from '../../../helpers';
import styled from 'styled-components';
import { usePresentationComponent } from '../../../AppContext';
var radioGroupFactory = function () {
    var getOptionsObject = function (option) {
        var localOption = typeof option === 'object' ? option : {
            label: '',
            value: '',
        };
        if (typeof option !== 'object') {
            localOption.label = "" + option;
            localOption.value = "" + option;
        }
        ;
        return localOption;
    };
    var DefaultRenderer = function (_a) {
        var label = _a.label, onChange = _a.onChange, value = _a.value, input = _a.input, props = __rest(_a, ["label", "onChange", "value", "input"]);
        return React.createElement(El, __assign({}, props));
    };
    var RadioGroup = function (props) {
        var _a = props.isInline, isInline = _a === void 0 ? true : _a, label = props.label, onChange = props.onChange, value = props.value, name = props.name, _b = props.options, options = _b === void 0 ? [] : _b, required = props.required, _c = props.input, input = _c === void 0 ? {} : _c, meta = props.meta, _d = props.className, className = _d === void 0 ? '' : _d, radioAttributes = __rest(props, ["isInline", "label", "onChange", "value", "name", "options", "required", "input", "meta", "className"]);
        var _e = meta || {}, invalid = _e.invalid, touched = _e.touched, error = _e.error;
        var isInvalid = touched && error;
        var hasPresentationComponent = !!usePresentationComponent("radioGroup");
        var Renderer = usePresentationComponent("radioGroup") || DefaultRenderer;
        var radioOptions = options.map(function (option, i) {
            var localOption = getOptionsObject(option);
            return React.createElement(Radio, __assign({ isInline: true, key: "option-" + i }, radioAttributes, { onChange: onChange, value: value }, input, localOption, { name: name }));
        });
        var renderDisplayText = function () {
            if (!label && !invalid)
                return null;
            var Error = isInvalid ? (ErrorTypes[error] || ErrorText) : null;
            if (hasPresentationComponent) {
                return isInvalid ? error :
                    label;
            }
            return React.createElement("div", { style: { width: "100%" } }, isInvalid
                ? Error && React.createElement(Error, { label: label, error: error })
                : React.createElement("span", { className: INPUT_LABEL },
                    label,
                    required && React.createElement("span", null, "*")));
        };
        return React.createElement(Renderer, { isInline: isInline, input: input, label: hasPresentationComponent ? renderDisplayText() : null, onChange: onChange, value: value, className: getClassName(className, RADIO_GROUP) },
            hasPresentationComponent ? null : renderDisplayText(),
            radioOptions);
    };
    return RadioGroup;
};
var El = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ",
    "\n"])), function (_a) {
    var isInline = _a.isInline;
    return isInline && "\n            ." + INPUT_GROUP + " {\n                margin-right: 1em;\n                margin-right: var(--ws-input-margin);\n            }\n        ";
});
export var RadioGroup = radioGroupFactory();
export var ReactiveRadioGroup = function (props) {
    // const { className, name, options } = props;
    return React.createElement(RadioGroup, __assign({}, useFieldApi(props)));
};
var templateObject_1;
